/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useRef } from 'react';

import PropTypes from 'prop-types';

import { ListLabelItemProps } from './ListLabelItemProps';

import './ListLabelItem.scss';

const ListLabelItem: FunctionComponent<ListLabelItemProps> = ({
    label,
    customContainerStyle,
    customLabelStyle,
}): JSX.Element => {
    const itemRef = useRef<HTMLDivElement>(null);
    const titleRef = useRef<HTMLDivElement>(null);

    const hasOverflowed =
        (titleRef.current?.scrollWidth || 0) > (itemRef.current?.clientWidth || 0);

    return (
        <div ref={itemRef} className={`item-container ${customContainerStyle || ''}`}>
            <span
                ref={titleRef}
                className={`title ${customLabelStyle || ''}`}
                style={hasOverflowed ? { overflow: 'hidden' } : {}}
            >
                {label}
            </span>
        </div>
    );
};

ListLabelItem.propTypes = {
    label: PropTypes.string.isRequired,
    customContainerStyle: PropTypes.string,
    customLabelStyle: PropTypes.string,
};

export default ListLabelItem;
